<template>
  <v-card class="naming-container">
    <div class="d-flex align-center justify-space-between">
      <div class="participants-title">Participantes</div>
      <v-btn
        flat
        small
        color="primary"
        style="max-width: 50px"
        v-if="!mandatoryNomination"
        @click="skip"
        >Pular</v-btn
      >
    </div>

    <div class="naming-subtitle">
      Os detalhes de acesso serão enviados para o email de inscrição.
    </div>
    <v-form ref="form" v-model="valid" v-if="orderTickets">
      <ticket-form
        v-for="(ticket, i) in orderTickets.filter(t => t.dados_extras.length)"
        :key="ticket.codigo"
        :index="i"
        :ticket="ticket"
        @save="saveNamedTicket"
      />
    </v-form>
    <next-step-button
      :enabled="valid"
      class="mt-4"
      :actionBeforeNextStep="{
        action: 'saveNamedTicket',
        payload: orderTickets,
      }"
    />
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import NextStepButton from '../UI/NextStepButton.vue';
import TicketForm from './TicketForm.vue';
export default {
  components: { NextStepButton, TicketForm },
  data() {
    return {
      valid: true,
      originalOrderTickets: [],
    };
  },
  computed: {
    ...mapGetters(['mandatoryNomination', 'orderTickets', 'eventID']),
  },
  mounted() {
    this.$store.dispatch('setDeliveryOption', 1);
    let checkoutState = JSON.parse(localStorage.getItem('checkoutState'));
    console.log('this.orderTickets', this.orderTickets);
    if (!checkoutState[this.eventID].namedTickets) {
      this.originalOrderTickets = JSON.parse(JSON.stringify(this.orderTickets));
      this.saveNamingStateOnLocalhost(this.orderTickets);
    } else
      this.originalOrderTickets = JSON.parse(
        JSON.stringify(checkoutState[this.eventID].namedTickets)
      );
  },
  methods: {
    skip() {
      this.saveNamingStateOnLocalhost(this.originalOrderTickets);
      this.$store.dispatch('nextStep');
    },
    saveNamingStateOnLocalhost(tickets) {
      let checkoutState = JSON.parse(localStorage.getItem('checkoutState'));
      localStorage.setItem(
        'checkoutState',
        JSON.stringify({
          ...checkoutState,
          [this.eventID]: {
            ...checkoutState[this.eventID],
            namedTickets: tickets,
          },
        })
      );
    },
    saveNamedTicket() {
      if (this.valid) {
        let el = window.document.getElementById('next-step-button');
        el.click();
      }
    },
  },
  watch: {
    orderTickets: {
      deep: true,
      handler(v) {
        if (v) {
          this.saveNamingStateOnLocalhost(v);
        }
      },
    },
  },
};
</script>

<style lang="stylus">
@import '~@/assets/nomination/nomination.styl';
@import '~@/assets/infos/forms/infos-sign-in.styl'
</style>
